import { Renderer2, Inject, Injectable, RendererFactory2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Observable, of } from 'rxjs';
import { BsApiService, GenericResponseResult } from '@brightside-web/desktop/data-access/core-services';
import { DevMenuService } from '@brightside-web/desktop/feature/dev-settings';

export interface SocureDocumentRequestResponse {
  payload: {
    docvTransactionToken: string;
  };
}

@Injectable()
export class SocureService {
  SCRIPT_PATH = 'https://websdk.socure.com/bundle.js';
  apiName = 'api-mobile';

  socureErrorType = {
    7011: 'Invalid Key',
    7014: 'Session Expired',
    7021: 'Initiate Session Failed',
    7022: 'Document Upload Failed',
    7101: 'Socure Key Empty',
    7102: 'Camera Permission Disabled',
    7103: 'No Internet Connection',
    7104: 'Scan Canceled By User',
    7106: 'Camera Error',
    7107: 'Unknown Error',
    7110: 'Consent Declined',
  };

  private renderer: Renderer2;
  private _bsApi = inject(BsApiService);
  private _devMenuService = inject(DevMenuService);

  constructor(@Inject(DOCUMENT) private document: Document, private _rendererFactory: RendererFactory2) {
    this.renderer = _rendererFactory.createRenderer(null, null);
  }

  loadSocureScript(): HTMLScriptElement {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = this.SCRIPT_PATH;
    this.renderer.appendChild(this.document.body, script);
    return script;
  }

  /**
   * Gets the docvTransactionToken from the backend to initiate Socure document verification.
   * This token is required for the SocureDocVSDK.launch() method.
   * When dev menu "Bad Socure token (next attempt)" is on, returns a fake invalid token on first call.
   *
   * @returns Observable containing the docvTransactionToken
   */
  getDocvTransactionToken(): Observable<(SocureDocumentRequestResponse & GenericResponseResult)> {
    if (this._devMenuService.consumeBadSocureTokenIfRequested()) {
      const fakeResponse: SocureDocumentRequestResponse & GenericResponseResult = {
        payload: { docvTransactionToken: `invalid-dev-${Date.now()}-${Math.random().toString(36).slice(2)}` },
        result: { status: 200, code: 'SERVICE_OK', message: '', suggestion: '', suggestionCopyKey: '', docs: '' },
      };
      return of(fakeResponse);
    }
    return this._bsApi.post<SocureDocumentRequestResponse>(
      this.apiName,
      '/accounts/kyc/token'
    );
  }

}
